import { PageBody } from "@/components/app-layout";
import DisplayEditor from "@/components/display/display-editor/DisplayEditor";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export default function InterviewSettingsPage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();

  const { kit, updateKit } = useKitData(groupUuid, kitUuid);

  if (!kit) {
    return null;
  }

  return (
    <PageBody>
      <DisplayEditor
        name={kit.name}
        description={kit.description}
        onNameChange={(name) => updateKit({ name })}
        onDescriptionChange={(description) => updateKit({ description })}
      />
    </PageBody>
  );
}
